import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Banner from '../components/Banner';
import Reaction from '../components/Reaction';
import Contact from '../components/Contact';
import LastUpdate from '../components/LastUpdate';

const FaqRegisterKtp = () => {

    React.useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }, []);

    // Mengubah format list <li> menjadi array of objects agar mudah di-map sesuai desain
    const reasons = [
        {
            label: "Alasan ke-1",
            title: "Verifikasi Identitas",
            desc: "Foto KTP digunakan untuk memverifikasi identitas pengguna secara resmi. Ini memastikan bahwa orang yang mendaftar adalah individu yang sebenarnya.",
            img: process.env.REACT_APP_S3 + "register_ktp.png"
        },
        {
            label: "Alasan ke-2",
            title: "Mencegah Penipuan",
            desc: "Foto selfie bersama KTP, digunakan untuk mencegah penyalahgunaan KTP oleh pihak tidak berwenang.",
            img: process.env.REACT_APP_S3 + "register_ktp.png" // Menggunakan gambar yang sama sementara, bisa diganti nanti
        },
        {
            label: "Alasan ke-3",
            title: "Pengalaman Pengguna yang Lebih Baik",
            desc: "Dengan memastikan identitas pengguna, aplikasi dapat menyediakan layanan yang lebih personal dan aman, seperti akses ke fasilitas atau layanan eksklusif yang hanya tersedia untuk pengguna terverifikasi.",
            img: process.env.REACT_APP_S3 + "register_ktp.png" // Menggunakan gambar yang sama sementara, bisa diganti nanti
        }
    ];

    return (
        <div className="bg-white min-h-screen  flex flex-col">
            <Navbar />
            
            {/* Banner Section */}
            <Banner
                image={process.env.REACT_APP_S3 + "banner_faq.png"} 
                beforePage="FAQ"
                currentPage="Detail FAQ" 
            />
            <div className="mx-auto px-4 md:px-24 w-full relative z-10 mb-16">
                <div className="rounded-2xl md:rounded-3xl">
                    <div className="mb-10 md:mb-16">
                        <h1 className="text-2xl md:text-3xl lg:text-3xl font-bold text-[#101828] mb-6 leading-snug">
                            Mengapa registrasi di summarecon apps memerlukan foto KTP dan foto Selfie?
                        </h1>
                    </div>

                    {/* Mapping Blok Konten (Kiri Teks, Kanan Gambar) */}
                    <div className="flex flex-col gap-12 md:gap-20">
                        <div className="flex flex-col md:flex-row gap-8 md:gap-12">
                            <div className="w-full md:w-1/2 text-left justify-center md:justify-end">
                                <label className="mt-4 text-[#101828] text-base md:text-base font-normal">
                                    Registrasi di aplikasi Summarecon yang memerlukan foto KTP dan foto selfie dilakukan untuk memastikan keamanan dan keaslian identitas pengguna. Berikut beberapa alasan spesifik mengapa foto KTP dan foto selfie diperlukan:
                                </label>
                                <ol className="list-decimal pl-5 mt-4 text-[#475467]">
                                    <li className="mb-4 font-bold">
                                        <strong className='text-[#101828]'>Verifikasi Identitas: </strong>
                                        <label className="font-normal text-[#475467]">
                                        Foto KTP digunakan untuk memverifikasi identitas pengguna secara resmi. Ini memastikan bahwa orang yang mendaftar adalah individu yang sebenarnya.
                                        </label>
                                    </li>
                                    <li className="mb-4">
                                        <strong className='text-[#101828]'>Mencegah Penipuan:</strong>
                                        <label className="font-normal text-[#475467]">
                                        Foto selfie bersama KTP, diggunakan untuk mencegah penyalahgunaan KTP oleh pihak tidak berwenang
                                        </label>
                                    </li>
                                    <li className="mb-4">
                                        <strong className='text-[#101828]'>Pengalaman Pengguna yang Lebih Baik:</strong>
                                        <label className="font-normal text-[#475467]">
                                            Dengan memastikan identitas pengguna, aplikasi dapat menyediakan layanan yang lebih personal dan aman, seperti akses ke fasilitas atau layanan eksklusif yang hanya tersedia untuk pengguna terverifikasi.
                                        </label>
                                    </li>
                                </ol>
                                <label className="mt-4 text-[#101828] block mb-4 text-base md:text-base font-normal">
                                    Proses ini mungkin terasa rumit, tetapi dilakukan untuk melindungi pengguna dan memastikan integritas sistem aplikasi. 
                                </label>
                                <label className="mt-4 text-[#101828] text-base md:text-base font-normal">
                                    Jika ada kekhawatiran tentang privasi, pengguna dapat membaca kebijakan privasi aplikasi untuk memahami bagaimana data mereka akan digunakan dan dilindungi.
                                </label>
                            </div>

                            {/* Kolom Kanan: Gambar */}
                            <div className="w-full md:w-1/2 flex justify-center md:justify-end">
                                {/* Box background hijau/abu-abu muda seperti di desain */}
                                <div className="rounded-3xl px-6 md:px-8 w-full max-w-[640px] flex justify-center items-center">
                                    <img
                                        src={process.env.REACT_APP_S3 + "register_ktp.png"}
                                        className="w-full h-auto object-contain drop-shadow-xl"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <LastUpdate/>
                </div>
            </div>
            
            <Contact />
            <Footer />
        </div>
    );
}

export default FaqRegisterKtp;